module.exports = __webpack_public_path__ + "img/asmnt.4c4ad335.svg";